import React from 'react';
import { useLanguage } from '@/context/language-context';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const SubscriptionSettings: React.FC = () => {
  const { t } = useLanguage();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('profile.subscription_settings') || 'Paramètres d\'abonnement'}</CardTitle>
      </CardHeader>
      <CardContent>
        <p>{t('profile.subscription_settings_description') || 'Formulaire temporaire - À implémenter'}</p>
      </CardContent>
    </Card>
  );
};

export default SubscriptionSettings; 